import { ItemIcon, Type } from "@similarweb/ui-components";
import type { Domain } from "../../../types";
import { DropdownSegmentItemWrapper, GroupItemSubText, GroupItemText, GroupTextWrapper, GroupWrapper } from "./styles";
import { Checkbox } from "@similarweb/ui-components";

type DropdownItemProps = {
    item: Domain;
    customOnClick: (domain: Domain) => void;
    isSelected: boolean;
    isDisabled: boolean;
};

const DropdownItem = ({ item, customOnClick, isSelected, isDisabled }: DropdownItemProps) => (
    <DropdownSegmentItemWrapper id={item.id}>
        <GroupWrapper>
            <ItemIcon
                iconSrc={item.image}
                iconType={Type.Website}
            />
            <GroupTextWrapper>
                <GroupItemText>{item.domain}</GroupItemText>
                <GroupItemSubText>{item.segmentName}</GroupItemSubText>
            </GroupTextWrapper>
        </GroupWrapper>
        <Checkbox
            selected={isSelected}
            onClick={() => !isDisabled && customOnClick(item)}
            label=""
            isDisabled={isDisabled}
        />
    </DropdownSegmentItemWrapper>
);

export default DropdownItem;
